import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { CanvasComponent } from './features/canvas/canvas.component';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.component').then(
        (mod) => mod.LoginComponent
      ),
    data: {
      queryParams: ['notAllowed']
    }
  },
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivateChild: [authGuard],
    loadComponent: () =>
      import('./features/dashboard/dashboard.component').then(
        (mod) => mod.DashboardComponent
      ),
    children: [
      {
        path: 'home',
        loadComponent: () =>
          import('./features/home/home.component').then(
            (mod) => mod.HomeComponent
          ),
      },
      {
        path: 'onboarding',
        loadComponent: () =>
          import('./features/signup/onboarding/onboarding.component').then(
            (mod) => mod.OnboardingComponent
          ),
      },
      {
        path: 'onboarding/successful',
        loadComponent: () =>
          import('./features/signup/onboarding/components/successful/successful.component').then(
            (mod) => mod.OnboardingSuccessfulComponent
          ),
      },
      {
        path: 'connections',
        loadComponent: () =>
          import('./features/connections/connections.component').then(
            (mod) => mod.ConnectionsComponent
          ),
      },

      {
        path: 'connections/single',
        loadComponent: () =>
          import(
            './features/connections/single/connections-single.component'
          ).then((mod) => mod.ConnectionsSingleComponent),
      },
      {
        path: 'data-catalog',
        loadComponent: () =>
          import('./features/data-catalog/data-catalog.component').then(
            (mod) => mod.DataCatalogComponent
          ),
      },
      {
        path: 'data-scopes',
        loadComponent: () =>
          import('./features/data-scopes/data-scopes.component').then(
            (mod) => mod.DataScopesComponent
          ),
      },
      {
        path: 'data-scopes/single',
        loadComponent: () =>
          import(
            './features/data-scopes/single/data-scopes-single.component'
          ).then((mod) => mod.DataScopesSingleComponent),
      },
      {
        path: 'data-copilot',
        loadComponent: () =>
          import('./features/data-copilot/data-copilot.component').then(
            (mod) => mod.DataCopilotComponent
          ),
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./features/data-copilot/single/data-copilot-single.component').then((mod) => mod.DataCopilotSingleComponent)
          },
          {
            path: 's/:scopeId',
            loadComponent: () =>
              import(
                './features/data-copilot/single/data-copilot-single.component'
              ).then((mod) => mod.DataCopilotSingleComponent),
          },
          {
            path: 'c/:id',
            loadComponent: () =>
              import(
                './features/data-copilot/single/data-copilot-single.component'
              ).then((mod) => mod.DataCopilotSingleComponent),
          }
        ],
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./features/reports/reports.component').then(
            (mod) => mod.ReportsComponent
          ),
      },
      {
        path: 'reports/single',
        loadComponent: () =>
          import(
            './shared/report-framework/report-framework/report-framework.component'
          ).then((mod) => mod.ReportFrameworkComponent),
      },
      {
        path: 'reports/saved/single',
        loadComponent: () =>
          import(
            './shared/report-framework/report-framework/report-framework.component'
          ).then((mod) => mod.ReportFrameworkComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/settings.component').then(
            (mod) => mod.SettingsComponent,
          ),
      },
      {
        path: 'settings/payment-success',
        loadComponent: () =>
          import('./features/settings/payment-success/success.component').then(
            (mod) => mod.SuccessComponent,
          ),
      },
      {
        path: 'canvas',
        loadComponent: () =>
          import('./features/canvas/canvas.component').then(
            (mod) => mod.CanvasComponent
          ),
        children: [
          {
            path: '',
            component: CanvasComponent
          },
          {
            path: 'create',
            loadComponent: () =>
              import('./features/canvas/components/create-canvas/create-canvas.component').then(
                (mod) => mod.CreateCanvasComponent
              ),
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/canvas/components/create-canvas/create-canvas.component').then(
                (mod) => mod.CreateCanvasComponent
              ),
          }
          
        ]
      },

    ],
  },
];
